export const initXsdConverterWidgetRepository = function() { return; };
